export enum GenderEnum {
  Male = "male",
  Female = "female",
  Private = "private",
}
